module.exports = "<div class=\"container background\">\n\n</div>"